import { TAB_INDEX_FOCUSABLE_ONLY, TAB_INDEX_FOCUSABLE_TAB_SEQUENCE } from "@multiweb/reactUtils/constants";
import { OptionalTabIndex, TabIndex } from "@multiweb/types/react";

/**
 * Funkce vrací tab index v závislosti na stavu `disabled`.
 * TODO: Zakazovat disabled elementům focus je z pohledu přístupnosti bad practice.
 * @param tabIndex Původní hodnota tab indexu {@link OptionalTabIndex}.
 * @param disabled Jestli je element ve stavu disabled.
 * @return {@link TAB_INDEX_FOCUSABLE_ONLY} pokud je `disabled` = _`true`_, v opačném případě vrací původní hodnotu `tabIndex`.
 */
export const getTabIndexBasedOnDisabled = (tabIndex: OptionalTabIndex, disabled: boolean): OptionalTabIndex =>
    disabled ? TAB_INDEX_FOCUSABLE_ONLY : tabIndex;

/**
 * Funkce vrací tab index na základě techniky "Roving tabindex".
 * @param focusable Jestli je element zaměřitelný.
 * @returns {@link TAB_INDEX_FOCUSABLE_TAB_SEQUENCE} pokud je `focusable` = _`true`_, v opačném případě vrací {@link TAB_INDEX_FOCUSABLE_ONLY}.
 * @see Pro více informací {@link https://developer.mozilla.org/en-US/docs/Web/Accessibility/Keyboard-navigable_JavaScript_widgets#managing_focus_inside_groups|developer.mozilla.org}
 */
export const getRovingTabIndex = (focusable?: boolean): TabIndex =>
    focusable ? TAB_INDEX_FOCUSABLE_TAB_SEQUENCE : TAB_INDEX_FOCUSABLE_ONLY;
